import React, {useEffect, useState} from 'react';
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import EditableTable from "../../../primer/Editable-Table";
import axios from "axios";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import {
    getECCategoryOptions,
    getECTypeOptions,
    getInvoiceTypesOptions,
    getVatExpenseClassificationType, vat39ACategories
} from "../../../../_helpers/sharedmydata";
import Input from "../../../common/Input";
import Loader from "../../../primer/POPUP-COMPONENTS/Loader/PrimerLoader";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import "./mydata-report.css";
import {fetchAdvancedTypesBuys, fetchBuysGeneralSettings} from "../../../../_apis/api";
import NewBuyModal from "../../../primer/POPUP-COMPONENTS/NewBuyModal/NewBuyModal";
import {
    checkPermission,
    getCategoriesByInvoiceType,
    getDefaultOptionByValue,
    getGreekCurrencyFormat,
    isEmpty
} from "../../../../_helpers/commonFunctions";
import {
    setBuysMyDataReportData,
    setBuysMyDataReportRequestData, setBuysMyDataReportSuppliersData,
    setBuysMyDataReportTotals, setForceRefreshBuysMyDataReport
} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import Alert from "react-bootstrap/Alert";
import {salesInvoiceTypesData} from "../../../../_data/mydata/salesInvoiceTypes";
import {Popover} from "antd";
import MassBuysModal from "../../../primer/POPUP-COMPONENTS/MassBuysModal";
import ReportsTemplate from "../../../common/ReportsTemplate";
import BetterCheckBox from "../../../common/BetterCheckBox";
import ClassificationsDifferencesTable from "../ClassificationsDifferencesTable";
import MassFetchClassificationsModal
    from "../../../primer/POPUP-COMPONENTS/MassClassifications/MassFetchClassificationsModal";
import MassSendClassificationsModal
    from "../../../primer/POPUP-COMPONENTS/MassClassifications/MassSendClassificationsModal";
import {
    openAccountingRecordLocal,
    openBuyLocal,
    openFixedAssetRecordLocal,
    openTabByType
} from "../../../../_helpers/tabOpeners";
import {FaFileInvoice, FaInfoCircle} from "react-icons/fa";
import {MdDeselect} from "react-icons/md";
import SendToAiModal from "../../../primer/POPUP-COMPONENTS/SendToAiModal";
import {RiGeminiFill} from "react-icons/ri";
import {formatAIDocumentStatus} from "../AI/aiHelper";
import {
    initialAiModuleRequestData, initialAiMrModuleRequestData,
    setAIModuleRequestData,
    setAIModuleType,
    setAIMrModuleRequestData
} from "../../../../_reducers/aiSlice";
import {useTranslation} from "../../../../hooks/useTranslation";

const BuysMydataReport = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const requestData = useSelector((state) => state.BUYS.myDataReportRequestData);
    const totals = useSelector((state) => state.BUYS.myDataReportTotals);
    const forceRefreshMyDataBuysReport = useSelector((state) => state.BUYS.forceRefreshMyDataBuysReport);

    const buysReportData = useSelector((state) => state.BUYS.buysMyDataReportData);
    const showSuppliersData = useSelector((state) => state.BUYS.buysMyDataReportSuppliersData);
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const [incrKey, setIncrKey] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const invoiceTypes = getInvoiceTypesOptions("all");
    const ecCategory = getECCategoryOptions(true);
    const ecType = getECTypeOptions(true);
    const vatExpenseTypes = getVatExpenseClassificationType();

    const [classificationsRowData, setClassificationsRowData] = useState({});
    const [showClassificationsModal, setShowClassificationsModal] = useState(false);
    const [classificationsTableData, setClassificationsTableData] = useState([]);
    const [pageChanged, setPageChanged] = useState(false);
    const [sendClassificationLoading, setSendClassificationLoading] = useState(false);

    const [showNewBuyModal, setShowNewBuyModal] = useState(false);
    const [showCancelExpenseModal, setShowCancelExpenseModal] = useState(false);
    const [transactionMode, setTransactionMode] = useState("");

    const [showMassFetchModal, setShowMassFetchModal] = useState(false);
    const [showMassFetchClassModal, setShowMassFetchClassModal] = useState(false);
    const [showMassSendClassModal, setShowMassSendClassModal] = useState(false);
    const [showMassSendAiModal, setShowMassSendAiModal] = useState(false);

    const buyMarkFromCloud = useSelector((state) => state.CLOUD.buyMarkFromCloud);
    const has39A = classificationsTableData?.some((el) => el.vatExemptionCategory === "16");
    const [forceRefreshReport, setForceRefreshReport] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const canSeeAI = checkPermission("custom-ai", permissionsData) && aiSettings?.enableCloudAI === true;

    const isDemoCompany = companyDetails?.isDemoCompany === true;

    useEffect(() => {
        if (forceRefreshReport) {
            fetchReport();
            setForceRefreshReport(false);
        }
    }, [forceRefreshReport]);

    useEffect(() => {
        if (forceRefreshMyDataBuysReport === "force") {
            dispatch(setForceRefreshBuysMyDataReport(""));
            fetchReport(true, false);
        } else if (buysReportData.length === 0 || forceRefreshMyDataBuysReport === "soft") {
            dispatch(setForceRefreshBuysMyDataReport(""));
            fetchReport(false, true);
        }
    }, [])

    useEffect(() => {
        if (isDemoCompany && moment(requestData.date_to, "DD/MM/YYYY").diff(moment(requestData.date_from, "DD/MM/YYYY"), "days") > 31) {
            dispatch(setBuysMyDataReportRequestData({...requestData, date_to: moment(requestData.date_from, "DD/MM/YYYY").add(30, "days").format("DD/MM/YYYY")}))
        }
    }, [requestData])

    useEffect(() => {
        dispatch(fetchBuysGeneralSettings({company: company.id}));
        dispatch(fetchAdvancedTypesBuys({company: company.id}));
    }, [])

    useEffect(() => {
        if (showCancelExpenseModal === false) {
            setTransactionMode("");
        }
    }, [showCancelExpenseModal])

    const invoicesFromChannelOptions = [
        {value: 'all', label: "Προβολή όλων"},
        {value: 'provider', label: "Μόνο από παρόχους ηλεκτρονικής τιμολόγησης"},
        {value: 'myData', label: "Μόνο εκτός παρόχων ηλεκτροκινικής τιμολόγησης"},
    ];

    const handleClassificationClicked = (rowData) => {
        if (rowData.hasOwnProperty('name')) {
            let cloneReqData = {...requestData};
            cloneReqData.showSuppliers = false;
            if((rowData?.vat === "000000000" || rowData?.vat === "999999999" || rowData?.vat === company.vatNumber)) {
                cloneReqData.invoiceType = [invoiceTypes.find((inv) => inv.value === rowData.name)];
            } else {
                cloneReqData.supplierVAT = rowData.vat;
            }
            dispatch(setBuysMyDataReportRequestData(cloneReqData));
            setForceRefreshReport(true);
            return;
        }
        if (rowData?.classifications.length > 0) {
            if (rowData.classifications?.some((el) => el.vatExemptionCategory === "16")) {
                const clone = structuredClone(rowData.classifications);
                for (let r of clone) {
                    if (r?.vatExemptionCategory === "16") {
                        if (isEmpty(r.vat39a)) r.vat39a = Number(+r.netPrice * 0.24).toFixed(2) || "0.00";
                        if (isEmpty(r.vat39aCategory)) r.vat39aCategory = "1";
                    }
                }
                setClassificationsTableData(clone);
            } else {
                setClassificationsTableData(rowData.classifications);
            }
        } else {
            setClassificationsTableData([]);
            toast.error("Δεν βρέθηκαν χαρακτηρισμοί.");
        }
        setClassificationsRowData(rowData);
        setShowClassificationsModal(true);
    }

    const saveClassifications = async (fromMass = false, res) => {
        const has39A = res.classifications?.some((el) => el.vatExemptionCategory === "16");
        if (res.classifications?.some((classification) => isEmpty(classification.classificationCategory) && !classification.recType)) {
            return toast.error("Παρακαλώ συμπληρώστε κατηγορία MyData σε όλες τις γραμμές.");
        }
        setSendClassificationLoading(true);
        let expensesClassifications = [];
        for (let line of res.classifications) {
            if (has39A) {
                if (line.vat39a) {
                    expensesClassifications.push({
                        "ecls:lineNumber": line.lineNumber,
                        "ecls:expensesClassificationDetailData": [
                            {
                                "ecls:classificationType": line.classificationType,
                                "ecls:classificationCategory": line.classificationCategory,
                                "ecls:amount": Number(line.netPrice).toFixed(2),
                            },
                            {
                                "ecls:classificationType": "VAT_366",
                                "ecls:amount": Number(line.netPrice).toFixed(2),
                                "ecls:vatAmount": Number(line.vat39a).toFixed(2),
                                "ecls:vatCategory": line.vat39aCategory,
                                "ecls:vatExemptionCategory": "16",
                            },
                        ],
                    })
                } else {
                    if (line.vatExpenseType && line.vatExpenseType !== "") {
                        expensesClassifications.push({
                            "ecls:lineNumber": line.lineNumber,
                            "ecls:expensesClassificationDetailData": [
                                {
                                    "ecls:classificationType": line.classificationType,
                                    "ecls:classificationCategory": line.classificationCategory,
                                    "ecls:amount": Number(line.netPrice).toFixed(2),
                                },
                                {
                                    "ecls:classificationType": line.vatExpenseType,
                                    "ecls:amount": Number(line.netPrice).toFixed(2),
                                    "ecls:vatAmount": Number(line.vatAmount).toFixed(2),
                                    "ecls:vatCategory": line.vatCategory,
                                },
                            ],
                        })
                    } else { // Throws 330 error on My Data (Used when no vatExpenseType, mostly for category2_5...)
                        expensesClassifications.push({
                            "ecls:lineNumber": line.lineNumber,
                            "ecls:expensesClassificationDetailData": [
                                {
                                    "ecls:classificationType": line.classificationType,
                                    "ecls:classificationCategory": line.classificationCategory,
                                    "ecls:amount": Number(+line.netPrice + +line.vatAmount).toFixed(2),
                                },
                            ],
                        })
                    }
                }
            } else {
                if (line.vatExpenseType && line.vatExpenseType !== "") {
                    expensesClassifications.push({
                        "ecls:lineNumber": line.lineNumber,
                        "ecls:expensesClassificationDetailData": [
                            {
                                "ecls:classificationType": line.classificationType,
                                "ecls:classificationCategory": line.classificationCategory,
                                "ecls:amount": line.netPrice,
                            },
                            {
                                "ecls:classificationType": line.vatExpenseType,
                                "ecls:amount": line.netPrice,
                            }
                        ]
                    })
                } else {
                    expensesClassifications.push({
                        "ecls:lineNumber": line.lineNumber,
                        "ecls:expensesClassificationDetailData": {
                            "ecls:classificationType": line.classificationType,
                            "ecls:classificationCategory": line.classificationCategory,
                            "ecls:amount": Number(Number(line.netPrice) + Number(line.vatAmount)).toFixed(2),
                        }
                    })
                }
            }
        }
        let requestToSend = {
            company: company.id,
            "ecls:invoiceMark": res.mark,
            "ecls:invoicesExpensesClassificationDetails": expensesClassifications,
            reportType: "buys",
            postPerInvoice: has39A ? "true" : "false",
        }
        try {
            const response = await axios.post(process.env.REACT_APP_API_URL2 + "/buy/sendClassifications", requestToSend, {
                headers: { 'Content-Type': 'application/json' }
            });
            setSendClassificationLoading(false);
            if (response.data.status === "200") {
                setShowClassificationsModal(false);
                if (!fromMass) {
                    toast.success(response.data.message);
                    fetchReport(false, true);
                } else {
                    return { status: "200", message: "OK" }
                }
            } else {
                if (!fromMass) {
                    toast.error(response.data.message);
                } else {
                    return { status: "400", message: response.data.message }
                }
            }
        } catch (err) {
            setSendClassificationLoading(false);
            console.log(err);
            if (!fromMass) toast.error("Σφάλμα κατά την αποστολή.");
            if (fromMass) return { status: "400", message: "Σφάλμα κατά την αποστολή."}
        }
    }

    const classificationsTableActions = {
        update: (data, id, rowIndex) => {
            let cloneClassifications = classificationsTableData.slice();
            if (cloneClassifications.length >= 0) {
                cloneClassifications = cloneClassifications.map((a) => Object.assign({}, a));
                if (data.vat39aCategory) {
                    const mult = data.vat39aCategory === "1" ? 0.24 : 0.17;
                    data.vat39a = Number(+cloneClassifications[rowIndex].netPrice * mult).toFixed(2) || "0.00";
                }
                cloneClassifications[rowIndex] = {...cloneClassifications[rowIndex], ...data};
            }
            setClassificationsTableData(cloneClassifications);
        },
        selected: () => {}
    }

    const handleApplyClassificationToAll = (rowData) => {
        if(!isEmpty(rowData.classificationType) && !isEmpty(rowData.classificationCategory)) {
            let newData = [...classificationsTableData];
            for (let line of newData) {
                line.classificationType = rowData.classificationType;
                line.classificationCategory = rowData.classificationCategory;
                if (!line.vat39a && Number(line?.vatAmount) > 0) line.vatExpenseType = rowData.vatExpenseType ? rowData.vatExpenseType : "";
            }
            setClassificationsTableData(newData);
        } else {
            toast.error("Επιλέξτε κατηγορία και τύπο.");
        }
    }
    const classifiedOptions = [
        { label: "Εμφάνιση όλων", value: "" },
        { label: "Μόνο χαρακτηρισμένων", value: "true" },
        { label: "Μόνο μη χαρακτηρισμένων", value: "false" },
        { label: "Μόνο με διαφορά χαρακτηρισμών με το MyData", value: "classificationsDifference"},
    ]
    const showFilterOptions = [{value: 'all', label: t('SalesMyData.table2.allDocuments')},{value: 'differences', label: t('SalesMyData.table2.onlyDifferences')}, {value: 'success', label: t('SalesMyData.table2.onlyTheSent')}, {value: 'failed', label: t('SalesMyData.table2.onlyTheFailed')}];

    const showSuppliersColumns = [
        {
            name: "Προμηθευτής - Τύπος Παραστατικού",
            field: "name",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΦΜ Προμηθευτή",
            field: "vat",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Πλήθος MyData",
            field: "countMyData",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Καθαρή Αξία MyData",
            field: "myDataNetValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Αξία ΦΠΑ MyData",
            field: "myDataVatValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Συνολική Αξία MyData",
            field: "myDataTotalValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Πλήθος ERP",
            field: "countErp",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Καθαρή Αξία ERP",
            field: "erpNetValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Αξία ΦΠΑ ERP",
            field: "erpVatValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
        {
            name: "Συνολική Αξία ERP",
            field: "erpTotalValue",
            width: "5%",
            inputType: {type: 'currency'}
        },
    ];

    const columns = [
        {
            name: t('SalesMyData.table.date'),
            field: "date",
            width: "7%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "MARK",
            field: "mark",
            width: "10%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Προμηθευτής",
            field: "supplierName",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "ΑΦΜ Προμηθευτή",
            field: "vat",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.invoiceType'),
            field: "myDataType",
            width: "12%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Αριθμός",
            field: "preNumberAndNumber",
            width: "4%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.netValue'),
            field: "totalNetValue",
            width: "6%",
            editable: false,
            inputType: {
                type: 'currency',
            }
        },
        {
            name: t('SalesMyData.table.vatAmount'),
            field: "totalVatValue",
            width: "6%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: "Σύνολο φόρων",
            field: "totalTaxes",
            width: "4%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: t('SalesMyData.table.totalValue'),
            field: "totalAmount",
            width: "6%",
            editable: false,
            inputType: {type: 'currency'}
        },
        {
            name: t('SalesMyData.table.erpStatus'),
            field: "myDataStatus",
            width: "6%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('SalesMyData.table.myDataStatus'),
            field: "myDataSentStatus",
            width: "6%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: <Popover placement={"top"} title={<div style={{textAlign: "center"}}>Σημείωση</div>} content={
                <div style={{maxWidth: "220px"}}>
                    Η ένδειξη "Χαρακτηρισμένο" αποθηκεύεται τοπικά, δε συγχρονίζεται με το MyData, με αποτέλεσμα τα έξοδα που
                    έχουν χαρακτηριστεί από εξωτερικό λογισμικό να φαίνονται ως μη χαρακτηρισμένα.
                </div>
            }><div style={{textAlign: "center"}}>Χαρακ<strong>*</strong></div></Popover>,
            field: "classified",
            width: "5%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Ενέργειες",
            field: "changeClassifications",
            width: "7%",
            editable: true,
            hiddenColumn: false,
            inputType: {
                type: "custom-render",
                render: (row, cell) => {
                    const parseIt = row?.myDataJSON ? JSON.parse(row.myDataJSON) : null;
                    return (
                        <div className={"d-flex justify-content-center"}>
                            <Button title={"Εμφάνιση Χαρακτηρισμών"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                e.stopPropagation();
                                e.currentTarget.blur();
                                handleClassificationClicked(row);
                            }}><FaInfoCircle /></Button>
                            {parseIt?.downloadingInvoiceUrl?._text && (
                                <Button title={"Εμφάνιση Παραστατικού"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                    window.open(parseIt?.downloadingInvoiceUrl?._text, "_blank");
                                }}><FaFileInvoice /></Button>
                            )}
                            {canSeeAI && (
                                <Popover placement={"top"} title={<div style={{textAlign: "center"}}>Κατάσταση AI</div>} content={
                                    <div style={{maxWidth: "220px"}}>{!isEmpty(row?.aiStatus) ? formatAIDocumentStatus(row?.aiStatus, true) : "Δεν έχει αποσταλεί στο Primer AI"}</div>
                                }><Button title={"Κατάσταση AI"} style={{padding: "7px"}} size={"sm"} className={"mr-1"} onClick={(e) => {
                                    e.stopPropagation();
                                    e.currentTarget.blur();
                                    if(!isEmpty(row?.aiStatus)) {
                                        if(row?.aiType === "file") {
                                            dispatch(setAIModuleType("files"));
                                            dispatch(setAIModuleRequestData({...initialAiModuleRequestData, general: row.mark}));
                                        } else if (row?.aiType === "mr") {
                                            dispatch(setAIModuleType("myDataClearance"));
                                            dispatch(setAIMrModuleRequestData({...initialAiMrModuleRequestData, general: row.mark}));
                                        }
                                        dispatch(openTabByType("ai-module", TABS_DATA));
                                    } else if (row.myDataStatus !== "sent") {
                                        setSelectedRows([String(row.mark)]);
                                        setShowMassSendAiModal(true);
                                    } else {
                                        toast.error("Το παραστατικό υπάρχει ήδη στο Primer ERP!");
                                    }
                                }}><RiGeminiFill /></Button></Popover>
                            )}
                        </div>
                    );
                }
            },
        },
    ];

    let classificationsColumns = [
        {
            name: "Αρ. Γραμμής",
            field: "lineNumber",
            width: "5%",
            editable: false,
            hiddenColumn: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('ProductsNewGeneral.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            disabled: true,
            width: "15%",
            inputType: {
                type: 'select',
                options: invoiceTypes,
            }
        },
        {
            name: t('ProductsNewGeneral.table.category'),
            field: "classificationCategory",
            editable: true,
            disabled: classificationsRowData?.myDataType === "17.2",
            width: "15%",
            inputType: {
                type: 'select',
                options: classificationsRowData?.myDataType === "17.2" ? ecCategory : getCategoriesByInvoiceType(classificationsRowData?.myDataType, "expense"),
            }
        },
        {
            name: t('ProductsNewGeneral.table.type'),
            field: 'classificationType',
            editable: true,
            disabled: classificationsRowData?.myDataType === "17.2",
            width: "15%",
            inputType: {
                type: 'select',
                options: ecType,
            }
        },
        {
            name: "Καθαρή Αξία",
            field: "netPrice",
            hiddenColumn: false,
            width: "10%",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: "Ποσό Φ.Π.Α.",
            field: "vatAmount",
            hiddenColumn: false,
            width: "10%",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: "Φ.Π.Α.",
            field: "vatCategory",
            hiddenColumn: false,
            width: "5%",
            editable: false,
            disabled: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Συνολική Αξία",
            field: "totalValue",
            hiddenColumn: false,
            width: "10%",
            editable: false,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                }
            }
        },
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: "vatExpenseType",
            editable: true,
            disabledCallback: (rowData) => (rowData.vat39a || Number(rowData?.vatAmount) === 0),
            width: "10%",
            inputType: {
                type: 'select',
                options: vatExpenseTypes,
            }
        },
        {
            name: "Ενέργειες",
            field: "buttonActions",
            editable: true,
            width: "10%",
            inputType: {
                config: {
                    disabled: false,
                    onClick: handleApplyClassificationToAll,
                    text: "Χαρ. όλων"
                },
                type: 'button-sm',
            }
        },
    ];

    if (has39A) {
        classificationsColumns = [...classificationsColumns.map((obj) => {
            return {
                ...obj,
                width: String(parseFloat(obj.width) - 2) + "%",
            }
        }), {
            name: "Φ.Π.Α. Άρθρου 39Α",
            field: "vat39a",
            editable: false,
            editableCallback: (rowData) => has39A && !isEmpty(rowData.vat39a),
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        }, {
            name: "Φ.Π.Α. Άθρ. 39Α %",
            field: "vat39aCategory",
            editable: false,
            editableCallback: (rowData) => has39A && !isEmpty(rowData.vat39a),
            inputType: {
                type: "select",
                options: vat39ACategories,
            }
        }]
    }

    const fetchReport = (forceRefresh = false, fromPagination = false) => {
        setLoading(true);
        let cloneReqData = {...requestData};
        cloneReqData.company = company.id;
        if(canSeeAI) cloneReqData.enabledAi = true;
        cloneReqData.year = String(company.year);
        if(!fromPagination) {
            cloneReqData.page = 1;
            setSelectedRows([]);
            dispatch(setBuysMyDataReportRequestData({...requestData, page: 1}));
        } else {
            dispatch(setBuysMyDataReportRequestData(cloneReqData));
        }
        let reqUrl = "/report/fetch-mydata-report";
        if (forceRefresh) {
            cloneReqData.page = 1;
            reqUrl = "/report/mydata-report";
            setShowLoader(true);
        }
        let invTypes = [];
        if (cloneReqData.invoiceType.length > 0) invTypes = cloneReqData.invoiceType.flatMap((o) => o.value);
        let classTypes = [];
        if (cloneReqData.classificationTypes.length > 0) classTypes = cloneReqData.classificationTypes.flatMap((o) => o.value);
        axios.post(process.env.REACT_APP_API_URL2 + reqUrl, {...cloneReqData, invoiceType: invTypes, classificationTypes: classTypes}, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            setLoading(false);
            setShowLoader(false);
            if(res.data.status === "200") {
                if (res.data.data?.data) {
                    let resData = [...res.data.data.data];
                    if(resData.length > 0) {
                        resData.forEach((row) => {
                            if(row.date) row.date = moment(row.date).format("DD/MM/YYYY");
                            if(row.preNumber && row.preNumber !== "noprefix") {
                                row.preNumberAndNumber = String(row.preNumber + " " + row.number);
                            } else {
                                row.preNumberAndNumber = row.number;
                            }
                            row.vatAmount = row.totalVatValue;
                        })
                    } else {
                        dispatch(setBuysMyDataReportSuppliersData([]));
                        dispatch(setBuysMyDataReportData([]));
                        dispatch(setBuysMyDataReportRequestData({...cloneReqData, page: 1, totalPages: 0, totalItems: 0}));
                        toast.info("Δεν βρέθηκε καμία αγορά.");
                    }
                    let newRequestData = {...cloneReqData};
                    if (res.data.data.totalPages) newRequestData = {...newRequestData, totalPages: res.data.data.totalPages, totalItems: res.data.data.totalItems};
                    if (res.data.totals) dispatch(setBuysMyDataReportTotals(res.data.totals));
                    if (res.data.filters) newRequestData = {...newRequestData, ...res.data.filters};
                    if (res.data.lastUpdate) newRequestData = {...newRequestData, lastUpdate: res.data.lastUpdate};
                    if (res.data.canFetchClassifications) newRequestData = {...newRequestData, canFetchClassifications: res.data.canFetchClassifications};
                    dispatch(setBuysMyDataReportRequestData(newRequestData));
                    dispatch(setBuysMyDataReportSuppliersData(res.data?.vatData));
                    dispatch(setBuysMyDataReportData(resData));
                    if (!fromPagination) toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                } else {
                    dispatch(setBuysMyDataReportSuppliersData([]));
                    dispatch(setBuysMyDataReportData([]));
                    dispatch(setBuysMyDataReportRequestData({...cloneReqData, page: 1, totalPages: 0, totalItems: 0}));
                    toast.info("Δεν βρέθηκε καμία αγορά.");
                }
            } else {
                dispatch(setBuysMyDataReportSuppliersData([]));
                dispatch(setBuysMyDataReportData([]));
                let zeroTotals = {...totals};
                for(let k in zeroTotals) zeroTotals[k] = 0;

                dispatch(setBuysMyDataReportTotals(zeroTotals));
                toast.error(res.data.message, {autoClose: 7000});
            }
        }).catch((err) => {
            setLoading(false);
            setShowLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    useEffect(() => {
        if (buyMarkFromCloud) {
            fetchAndOpenUniqueBuy(buyMarkFromCloud);
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(false, true);
        }
    }, [pageChanged])

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [buysReportData, selectedRows])

    const handlePage = (str) => {
        if(str === "first") {
            dispatch(setBuysMyDataReportRequestData({...requestData, page: 1}));
            setPageChanged(true);
        } else if (str === "previous") {
            dispatch(setBuysMyDataReportRequestData({...requestData, page: requestData.page - 1}));
            setPageChanged(true);
        } else if (str === "next") {
            dispatch(setBuysMyDataReportRequestData({...requestData, page: requestData.page + 1}));
            setPageChanged(true);
        } else if (str === "last") {
            dispatch(setBuysMyDataReportRequestData({...requestData, page: requestData.totalPages}));
            setPageChanged(true);
        }
    }

    const handleFilterChange = (e, type, name) => {
        let cloneReqData = {...requestData};
        if (type === "datebox" && !isEmpty(e)) {
            cloneReqData = {...cloneReqData, [name] : moment(e).format("DD/MM/YYYY")};
        } else if(name === "aiStatus") {
            cloneReqData = {...cloneReqData, [name] : e.flatMap((o) => o.value)};
        } else if (type === "msdd") {
            cloneReqData = {...cloneReqData, [name] : e};
        } else if (type === "input") {
            cloneReqData = {...cloneReqData, [name] : e.target.value}
        } else if (type === "dropdown") {
            cloneReqData = {...cloneReqData, [name] : e.value};
        } else if (type === "ac") {
            cloneReqData = {...cloneReqData, [name] : e.row.name};
        } else if (type === "checkbox") {
            cloneReqData = {...cloneReqData, [name] : e.target.checked};
        }
        dispatch(setBuysMyDataReportRequestData(cloneReqData));
    }

    const handleShowAssetRecord = () => {
        if (classificationsRowData.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/fixedassets/get-asset-record-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: classificationsRowData.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setShowClassificationsModal(false);
                    setShowNewBuyModal(false);
                    dispatch(openFixedAssetRecordLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleShowExistingAccountingRecord = () => {
        if (classificationsRowData.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/buy/get-accounting-record-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: classificationsRowData.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setShowClassificationsModal(false);
                    setShowNewBuyModal(false);
                    dispatch(openAccountingRecordLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleShowExistingBuy = () => {
        if (classificationsRowData.mark) {
            axios.get(process.env.REACT_APP_API_URL2 + "/buy/get-buy-by-mark", {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    company: company.id,
                    mark: classificationsRowData.mark,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setShowClassificationsModal(false);
                    setShowNewBuyModal(false);
                    if (res.data.data) {
                        dispatch(openBuyLocal(res.data.data, TABS_DATA));
                    } else {
                        toast.error("Σφάλμα κατά την φόρτωση της αγοράς.");
                    }
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        } else {
            toast.error("Σφάλμα κατά την εύρεση του ΜΑΡΚ.");
        }
    }

    const handleSendExpenseClassificationWithTransactionMode = () => {
        if (transactionMode === "1" || transactionMode === "2") {
            axios.post(process.env.REACT_APP_API_URL2 + "/buy/sendClassificationsTransactionMode", {reportType: "buys", company: company.id, mark: classificationsRowData.mark, transactionMode: transactionMode}, {
                headers: { 'Content-Type': 'application/json' },
            }).then((res) => {
                setShowCancelExpenseModal(false);
                if (res.data.status === "200") {
                    toast.success("OLA KOMPLE");
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                setShowCancelExpenseModal(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    const classificationIsASale = () => {
        return salesInvoiceTypesData.find((el) => String(el.id) === String(classificationsRowData.myDataType));
    }

    const handleBuyCorrelation = (mark) => {
        axios.post(process.env.REACT_APP_API_URL2 + "/buy/correlate-buy-from-report", {company: company.id, mark: mark}, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η συσχέτιση έγινε επιτυχώς.");
                fetchReport(false, true);

                let clonedData = structuredClone(classificationsRowData);
                delete clonedData.correlatable;
                delete clonedData.correlatable_id;
                clonedData.myDataStatus = "sent";
                setClassificationsRowData(clonedData);
            } else {
                toast.error(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchAndOpenUniqueBuy = (mark) => {
        axios.get(`${process.env.REACT_APP_API_URL2}/buy/get-buy-by-mark-mydata`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                mark: mark,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const rowData = res.data.data;
                if (rowData.date) rowData.date = moment(rowData.date).format("DD/MM/YYYY");
                if (rowData.preNumber && rowData.preNumber !== "noprefix") {
                    rowData.preNumberAndNumber = String(rowData.preNumber + " " + rowData.number);
                } else {
                    rowData.preNumberAndNumber = rowData.number;
                }
                rowData.vatAmount = rowData.totalVatValue;

                setClassificationsRowData(rowData);
                setTimeout(() => {
                    setShowNewBuyModal(true);
                }, 200)
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const aiStatusOptions = [
        {label: "Καταχωρημένο", value: "complete"},
        {label: "Αναμονή ενέργειας χρήστη", value: "waiting_user"},
        {label: "Επεξεργασία από AI", value: "pending"},
        {label: "Απόρριψη από χρήστη", value: "declined"},
        {label: "Σφάλμα", value: "error"},
        {label: "Μη Απεσταλμένο", value: "notSent"},
    ]

    const sendInvoiceToAi = (mark, myDataJSON) => {
        axios.post(process.env.REACT_APP_API_URL2 + "/ai/mydata-add-to-ai", {company: company.id, mark: mark, myDataJSON, type: "buy"}, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Το παραστατικό εστάλη στο Primer Ai");
                setShowClassificationsModal(false);
                fetchReport();
            } else {
                toast.error(res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return(
        <React.Fragment>
            <ReportsTemplate templateType={"buys-mydata-report"} requestData={requestData} fetchReport={() => fetchReport()} setRequestData={(data) => dispatch(setBuysMyDataReportRequestData(data))} header={"Αναφορά MyData Αγορών"} />
            {showLoader && (<Loader />)}
            <div hidden={showLoader} onKeyDown={((e) => {
                if(e.key === "Enter") fetchReport()
            })}>
                {((isEmpty(requestData.date_from) || isEmpty(requestData.date_to))
                    || (!isEmpty(requestData.date_from) && !isEmpty(requestData.date_to) && moment(requestData.date_to, "DD/MM/YYYY").diff(moment(requestData.date_from, "DD/MM/YYYY"), "months") >= 1)) && (
                    <Alert variant={"secondary"}>
                        Επιλέγοντας χρονικό περιθώριο μεγαλύτερο του ενός μηνός, υπάρχει πιθανότητα η διαδικασία ανάκτησης των παραστατικών να καθυστερήσει.
                    </Alert>
                )}
                <Row>
                    <label className={"text-muted"}><i>Φίλτρα αναζήτησης MyData</i></label>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => dispatch(setBuysMyDataReportRequestData({
                                ...requestData,
                                date_from: from,
                                date_to: to
                            }))}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_from"
                            selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                            label={t('SalesMyData.dateFrom')}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_from")}
                            allowOtherYears={false}
                        />
                    </Col>
                    <Col md={2}>
                        <DateBox
                            name="date_to"
                            selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                            label={t('SalesMyData.dateTo')}
                            onChange={(e) => handleFilterChange(e, "datebox", "date_to")}
                            allowOtherYears={false}
                        />
                    </Col>
                    <Col md={3}>
                        {!isEmpty(requestData.lastUpdate) && (
                            <Badge bg={"primary"} style={{marginTop: "26px"}}>
                                Τελευταία ανανέωση από το My Data: <br/>
                                {moment(requestData.lastUpdate).format("DD/MM/YYYY HH:mm:ss")}
                            </Badge>
                        )}
                    </Col>
                    <Col md={3}>
                        <div style={{display: "flex", width: "100%"}}>
                            <Button onClick={() => fetchReport(true)} className={"float-right"} disabled={loading}>
                                Εφαρμογή φίλτρων & αναζήτηση από MyData{" "}
                                {loading && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                            </Button>
                        </div>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <label className={"text-muted"}><i>Φίλτρα Αναζήτησης</i></label>
                    <Col md={3}>
                        <Dropdown
                            label={t('SalesMyData.invoiceType')}
                            name="invoiceType"
                            defaultValue={requestData.invoiceType}
                            key={Math.random()}
                            multiSelect={true}
                            enabledValue={true}
                            options={invoiceTypes}
                            onChange={(e) => handleFilterChange(e, "msdd", "invoiceType")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            label={"ΑΦΜ Προμηθευτή"}
                            name={"supplierVAT"}
                            value={requestData.supplierVAT}
                            onChange={(e) => handleFilterChange(e, "input", "supplierVAT")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            label={"Εμφάνιση φίλτρου"}
                            options={showFilterOptions}
                            defaultValue={requestData["showFilter"]}
                            value={requestData["showFilter"] ? getDefaultOptionByValue(showFilterOptions, requestData["showFilter"], "value", "label", "value") : ""}
                            enabledValue={true}
                            name="showFilter"
                            searchEnable={true}
                            onChange={(e) => handleFilterChange(e, "dropdown", "showFilter")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            options={classifiedOptions}
                            name={"classified"}
                            label={"Εμφάνιση χαρακτηρισμένων"}
                            defaultValue={classifiedOptions.find((el) => el.value === requestData.classified)}
                            key={Math.random()}
                            onChange={(e) => handleFilterChange(e, "dropdown", "classified")}
                        />
                    </Col>
                    <Col md={3}>
                        <BetterCheckBox
                            name={"showAccounting"}
                            className={"mt-4"}
                            text={"Εμφάνιση εγγραφών από Λογιστική"}
                            checked={requestData.showAccounting}
                            onChange={(e) => handleFilterChange(e, "checkbox", "showAccounting")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <Input
                            type={"text"}
                            label={"Αριθμός τιμολογίου από"}
                            name={"number_from"}
                            autoComplete={"off"}
                            value={requestData.number_from}
                            placeholder={"Αριθμός τιμολογίου από"}
                            onChange={(e) => handleFilterChange(e, "input", "number_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"text"}
                            label={"Αριθμός τιμολογίου μέχρι"}
                            name={"number_to"}
                            autoComplete={"off"}
                            value={requestData.number_to}
                            placeholder={"Αριθμός τιμολογίου μέχρι"}
                            onChange={(e) => handleFilterChange(e, "input", "number_to")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Συνολική αξία από"}
                            name={"totalSum_from"}
                            autoComplete={"off"}
                            value={requestData.totalSum_from}
                            onChange={(e) => handleFilterChange(e, "input", "totalSum_from")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            type={"number"}
                            label={"Συνολική αξία μέχρι"}
                            name={"totalSum_to"}
                            autoComplete={"off"}
                            value={requestData.totalSum_to}
                            onChange={(e) => handleFilterChange(e, "input", "totalSum_to")}
                        />
                    </Col>
                    <Col md={2}>
                        <Dropdown
                            name={"invoicesFromChannel"}
                            label={"Κανάλι myDATA"}
                            options={invoicesFromChannelOptions}
                            defaultValue={invoicesFromChannelOptions.find((el) => requestData.invoicesFromChannel === el.value)}
                            onChange={(e) => handleFilterChange(e, "dropdown", "invoicesFromChannel")}
                        />
                    </Col>
                    <Col md={2}>
                        <BetterCheckBox
                            name={"showSuppliers"}
                            className={"mt-4"}
                            text={"Εμφάνιση αποτελεσμάτων ανά προμηθευτή"}
                            checked={requestData.showSuppliers}
                            onChange={(e) => handleFilterChange(e, "checkbox", "showSuppliers")}
                        />
                    </Col>
                </Row>
                <Row className={"justify-content-end mt-2"}>
                    <Col md={canSeeAI ? 3 : 6}>
                        <Input
                            name={"marks"}
                            label={"MARKS διαχωρισμένα με κόμμα (,)"}
                            value={requestData.marks}
                            autoComplete={"off"}
                            onChange={(e) => handleFilterChange(e, "input", "marks")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            label={"Τύποι E3"}
                            name={"classificationTypes"}
                            options={ecType}
                            multiSelect={true}
                            defaultValue={requestData.classificationTypes}
                            onChange={(e) => handleFilterChange(e, "msdd", "classificationTypes")}
                        />
                    </Col>
                    {canSeeAI && (
                        <Col md={3}>
                            <Dropdown
                                name={"aiStatus"}
                                label={"Κατάσταση Επεξεργασίας AΙ"}
                                multiSelect={true}
                                options={aiStatusOptions}
                                defaultValue={aiStatusOptions.filter((el) => requestData.aiStatus.includes(el.value))}
                                onChange={(e) => handleFilterChange(e, "msdd", "aiStatus")}
                            />
                        </Col>
                    )}
                    <Col md={3}>
                        <Button onClick={() => fetchReport()} className={"float-right"} style={{marginTop: "20px"}} disabled={loading}>
                            Εφαρμογή φίλτρων{" "}
                            {loading && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                        </Button>
                    </Col>
                </Row>
                {requestData.totalPages > 0 && buysReportData.length > 0 && (
                    <React.Fragment>
                        <hr />
                        <div className={"d-flex justify-content-end mb-2"}>
                            {canSeeAI && (
                                <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassSendAiModal(true)}>{selectedRows.length > 0 ? "Αποστολή επιλεγμένων στο Primer AI" : "Μαζική αποστολή στο Primer AI"}</Button>
                            )}
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassSendClassModal(true)}>{selectedRows.length > 0 ? "Αποστολή χαρακτηρισμών επιλεγμένων" : "Μαζική αποστολή χαρακτηρισμών"}</Button>
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassFetchClassModal(true)}>{selectedRows.length > 0 ? "Άντληση χαρακτηρισμών επιλεγμένων" : "Μαζική άντληση χαρακτηρισμών"}</Button>
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowMassFetchModal(true)}>{selectedRows.length > 0 ? "Δημιουργία αγορών επιλεγμένων" : "Μαζική δημιουργία αγορών"}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("first")}>{t('SalesMyData.first')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1} onClick={() => handlePage("previous")}>{t('SalesMyData.previous')}</Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1" bg="primary">{t('SalesMyData.page')} {requestData.page} / {requestData.totalPages}</Badge>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === requestData.totalPages} onClick={() => handlePage("next")}>{t('SalesMyData.next')}</Button>
                            <Button size={"sm"} className={"mr-1"} disabled={requestData.page === requestData.totalPages} onClick={() => handlePage("last")}>{t('SalesMyData.last')}</Button>
                        </div>
                        {requestData.totalItems !== 0 && (
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    {selectedRows.length > 0 && (
                                        <React.Fragment>
                                            <i>Έχετε επιλέξει {selectedRows.some((el) => el === -1) ? requestData.totalItems - selectedRows.filter((el) => el !== -1).length : selectedRows.length} παραστατικά</i>
                                            <div className={"ai-module-button ai-module-reprocess-style ml-2 pr-2"} title={"Αποεπιλογή"} onClick={() => {
                                                setSelectedRows([]);
                                            }}><MdDeselect size={22} /> Αποεπιλογή όλων</div>
                                        </React.Fragment>
                                    )}
                                </div>
                                <div>
                                    <i>Σύνολο Αποτελεσμάτων: {requestData.totalItems}</i>
                                </div>
                            </div>
                        )}
                        <EditableTable
                            key={"MyData Report Buys" + incrKey}
                            tableName="MyData Report Buys"
                            data={requestData?.showSuppliers ? showSuppliersData : buysReportData}
                            allowPagination={false}
                            allowToggleColumns={true}
                            allowInsertRow={false}
                            allowSelectionCheckbox={true}
                            enableNewRowCheckbox={true}
                            allowBulkActions={true}
                            allowPrintResults={true}
                            reportExcelPrint={true}
                            company={company}
                            filters={requestData}
                            actionButtons={{ print: false, delete: false, export: false, edit: false }}
                            allowActions={false}
                            columns={requestData?.showSuppliers ? showSuppliersColumns : columns}
                            filtersConfig={["quick-edit", "delete"]}
                            onRowClick={(e, row) => handleClassificationClicked(row)}
                            fixedLayout={true}
                            selectedRows={selectedRows}
                            setSelectedRows={((rows) => setSelectedRows(rows))}
                            selectedRowKey={"mark"}
                            totalItems={requestData?.totalItems || 0}
                        />
                        <Row className="justify-content-end mt-3">
                            <Col md={4} className="d-flex justify-content-end">
                                <table className="table table-bordered mb-3">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign: "center"}}>{t('SalesMyData.pageTotals')}</td>
                                            <td style={{textAlign: "center"}}>{t('SalesMyData.TotalsERP')}</td>
                                            <td style={{textAlign: "center"}}>{t('SalesMyData.TotalsMyData')}</td>
                                            <td style={{textAlign: "center"}}>{t('SalesMyData.differences')}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">{t('SalesMyData.totalsCount')}</td>
                                            <td>{totals.totalCount}</td>
                                            <td>{totals.totalCountMyData}</td>
                                            <td>{Math.abs(totals.totalCount - totals.totalCountMyData)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">{t('SalesMyData.totalNetValue')}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalNetValue)}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalNetValueMyData)}</td>
                                            <td>{getGreekCurrencyFormat(Math.abs(totals.totalNetValueMyData - totals.totalNetValue))}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">{t('SalesMyData.totalVatAmount')}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalVatValue)}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalVatValueMyData)}</td>
                                            <td>{getGreekCurrencyFormat(Math.abs(totals.totalVatValueMyData - totals.totalVatValue))}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">{t('SalesMyData.totalValue')}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalValue)}</td>
                                            <td>{getGreekCurrencyFormat(totals.totalValueMyData)}</td>
                                            <td>{getGreekCurrencyFormat(Math.abs(totals.totalValueMyData - totals.totalValue))}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className="justify-content-end">
                            <Col md={4} className={"d-flex justify-content-end"}>
                                {Number(totals.totalValue.toFixed(2) - totals.totalValueMyData.toFixed(2)) === 0 ? (
                                    <p style={{ color: 'green' }}><b>{t('SalesMyData.discordOk')}</b></p>
                                ) : (
                                    <p style={{ color: 'red' }}><b>{t('SalesMyData.discord')}</b></p>
                                )}
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>

            <Modal backdrop={"static"} dialogClassName={"buysModalBig"} show={showClassificationsModal} onHide={() => setShowClassificationsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SalesMyData.table.classificationsModalTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditableTable
                        key={Math.random()}
                        tableName={"MyData Report Classifications Buys"}
                        data={classificationsTableData}
                        allowActions={false}
                        onUpdate={classificationsTableActions}
                        columns={classificationsColumns}
                        allowBulkActions={true}
                        actionButtons={{ print: false, delete: false, export: false, edit: false }}
                    />
                    {classificationsRowData.correlatable === "true" && (
                        <div>
                            Το παραστατικό μπορεί να συσχετιστεί με αγορά από το ERP. <Button size={"sm"} onClick={() => handleBuyCorrelation(classificationsRowData.mark)}>Συσχέτιση</Button>
                        </div>
                    )}
                    <ClassificationsDifferencesTable
                        reportType={"buys"}
                        classificationsRowData={classificationsRowData}
                        successfullCallback={() => {
                            setShowClassificationsModal(false);
                            fetchReport();
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    {classificationIsASale() && false && (
                        <React.Fragment>
                            <Button onClick={() => {
                                setShowClassificationsModal(false);
                                setShowCancelExpenseModal(true);
                                setTransactionMode("1");
                            }}>Απόρριψη Παραστατικού</Button>
                            <Button onClick={() => {
                                setShowClassificationsModal(false);
                                setShowCancelExpenseModal(true);
                                setTransactionMode("2");
                            }}>Απόρριψη Παραστατικού λόγω ασυμφωνίας ποσών</Button>
                        </React.Fragment>
                    )}
                    {!isEmpty(classificationsRowData.mark) && classificationsRowData.myDataStatus === "sent" && (
                        <>
                        {classificationsRowData?.existsInAccounting === "true" ? (
                            <Button variant={"primary"} onClick={() => handleShowExistingAccountingRecord()}>Εμφάνιση Λογιστικού Άρθρου</Button>
                        ) : classificationsRowData?.existsInAssetRecords === "true" ? (
                            <Button variant={"primary"} onClick={() => handleShowAssetRecord()}>Εμφάνιση Απόσβεσης</Button>
                        ) : (
                            <Button variant={"primary"} onClick={() => handleShowExistingBuy()}>Εμφάνιση αγοράς</Button>
                        )}
                        </>
                    )}
                    {(classificationsRowData.myDataStatus !== "sent" && isEmpty(classificationsRowData?.aiStatus) && canSeeAI && checkPermission("custom-ai", permissionsData)) && (
                        <Button variant="primary" onClick={() => sendInvoiceToAi(classificationsRowData?.mark, classificationsRowData?.myDataJSON)}>Αποστολή στο Primer Ai</Button>
                    )}
                    {classificationsRowData.myDataStatus !== "sent" && classificationIsASale() && (
                        <Button variant="primary" onClick={() => {
                            setShowClassificationsModal(false);
                            setShowNewBuyModal(true);
                        }}>Δημιουργία Αγοράς & Αυτ. Χαρακτηρισμός</Button>
                    )}
                    <Button variant="outline-primary" onClick={() => setShowClassificationsModal(false)}>Κλείσιμο</Button>
                    <Button variant="primary" onClick={() => saveClassifications(false, {...classificationsRowData, classifications: classificationsTableData})}>Αποθήκευση & Αποστολή Χαρακτηρισμών {sendClassificationLoading && <Spinner animation="border" variant="dark" />}</Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showCancelExpenseModal} onHide={() => setShowCancelExpenseModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Απόρριψη παραστατικού</Modal.Title>
                </Modal.Header>
                <Modal.Body>Είσαστε σίγουροι ότι θέλετε να απορρίψετε το παραστατικό με ΜΑΡΚ: {classificationsRowData.mark} ;</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowCancelExpenseModal(false)}>Όχι, κλείσιμο</Button>
                    <Button variant="primary" onClick={() => handleSendExpenseClassificationWithTransactionMode()}>Ναι, απόρριψη</Button>
                </Modal.Footer>
            </Modal>

            <NewBuyModal
                show={showNewBuyModal}
                setShow={(bool) => {
                    if (!buyMarkFromCloud) setShowNewBuyModal(bool)
                }}
                classificationsRowData={classificationsRowData}
                refreshFunction={fetchReport}
                has39A={has39A}
            />

            <MassBuysModal
                show={showMassFetchModal}
                setShow={setShowMassFetchModal}
                filters={requestData}
                selectedRows={selectedRows}
                successfulCallback={() => fetchReport(false)}
            />

            <MassFetchClassificationsModal
                show={showMassFetchClassModal}
                setShow={setShowMassFetchClassModal}
                reportType={"buys"}
                filters={requestData}
                selectedRows={selectedRows}
                successfullCallback={() => fetchReport(false)}
            />

            <MassSendClassificationsModal
                show={showMassSendClassModal}
                setShow={setShowMassSendClassModal}
                reportType={"buys"}
                filters={requestData}
                selectedRows={selectedRows}
                sendClassifications={saveClassifications}
                successfullCallback={() => fetchReport(false)}
            />

            <SendToAiModal
                show={showMassSendAiModal}
                setShow={setShowMassSendAiModal}
                reportType={"buys"}
                filters={requestData}
                selectedRows={selectedRows}
                successfullCallback={() => fetchReport(false)}
            />
        </React.Fragment>
    )
}

export default BuysMydataReport
